export default {
  action: 'bolt',
  add: 'plus',
  back: 'chevron-left',
  cancel: 'times',
  close: 'times',
  delete: 'trash',
  downArrow: 'angle-down',
  download: 'external-link-square',
  edit: 'pencil',
  invite: 'user-plus',
  leftArrow: 'angle-left',
  loading: 'refresh',
  locked: 'lock',
  merge: 'share-alt fa-flip-horizontal',
  next: 'chevron-right',
  previous: 'chevron-left',
  print: 'print',
  rightArrow: 'angle-right',
  report: 'file-text',
  save: 'check',
  search: 'search',
  share: 'share',
  submit: 'check',
  success: 'check',
  upArrow: 'angle-up',
  upload: 'upload',
  warn: 'exclamation-circle',
  externalModal: 'share-square'
};


// WEBPACK FOOTER //
// ./src/js/util/constants/icons.js